<sps-login
  (successfulLogin)="onLogin()"
  (unverifiedEmail)="onUnverified($event)"
  [translations]="this.loginLabels | async"
  [showError]="true"
  (errorEvent)="onError($event)"
>
  <ng-container header>
    @if (isDarkMode$ | async) {
      <img ngSrc="assets/logo-white.svg" alt="Speaksee logo" width="300" height="60" priority />
    } @else {
      <img ngSrc="assets/logo.svg" alt="Speaksee logo" width="300" height="60" priority />
    }
    <span> {{ 'login.slogan' | transloco }} </span>
  </ng-container>
  <ng-container footer>
    <div class="register">
      <span>
        {{ 'login.sign_up_text' | transloco }}
      </span>
      <a [href]="registerURL">{{ 'login.sign_up' | transloco }}</a>
    </div>

    <div class="trouble">
      <span>{{ 'login.trouble_signing_in' | transloco }} </span>
      <a [href]="resetPasswordURL">{{
        'login.reset_password_button' | transloco
      }}</a>
    </div>

    <div class="faq">
      <span>{{ 'login.faq' | transloco }} </span>
      <a [href]="supportURL">{{
        'login.faq_link' | transloco
      }}</a>
    </div>
  </ng-container>
</sps-login>

<ng-template #emailDialog>
  <h2 matDialogTitle>
    {{ 'login.email_not_active_popup.header' | transloco }}
  </h2>
  <mat-dialog-content>
    <p [innerHTML]="'login.email_not_active_popup.body' | transloco"></p>
    <a [href]="requestEmail + '?email=' + this.email" target="_blank"
      >{{ 'login.email_not_active_popup.request_new' | transloco }}</a
    >
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button color="primary" mat-dialog-close>
      {{ 'login.email_not_active_popup.close' | transloco }}
    </button>
  </mat-dialog-actions>
</ng-template>
